import React, {Component} from 'react';
import Pluralize from 'react-pluralize';
import Proptypes from 'prop-types';
import {UncontrolledTooltip} from 'reactstrap';
import {connect} from 'react-redux';
import {openConfirmation} from '../../redux/actions';
import FloatToolbar from '../FloatToolbar';

type TableFloatToolbarProps = {
    selectedItems: [],
    additionalActions?: [],
    onUnselectAll?: Proptypes.func,
    onView?: Proptypes.func,
    onEdit?: Proptypes.func,
    onDelete?: Proptypes.func,
    onDeleteMessage?: Proptypes.func | string,
    openConfirmation?: Proptypes.func,
};

class TableFloatToolbar extends Component<TableFloatToolbarProps> {
    handleOnDelete = () => {
        const length = this.props.selectedItems.length
        console.log(typeof this.props.onDeleteMessage)
        const onDeleteMessage = typeof this.props.onDeleteMessage === 'string' ?
            this.props.onDeleteMessage.format(length) : this.props.onDeleteMessage;
        let deleteMessage = onDeleteMessage ? onDeleteMessage :
            `Do you really want to delete ${length} ${length === 1 ? 'item' : 'items'}?`;
        console.log(deleteMessage instanceof String)
        this.props.openConfirmation(deleteMessage, {
            items: this.props.selectedItems,
            data: this.props.data
        }, this.props.onDelete);
        // props.onDelete(props.selectedItems);
    };

    handleOnView = () => {
        if (this.props.selectedItems && this.props.selectedItems.length === 1) {
            this.props.onView(this.props.selectedItems[0])
        }
    };

    handleOnEdit = () => {
        if (this.props.selectedItems && this.props.selectedItems.length === 1) {
            this.props.onEdit(this.props.selectedItems[0])
        }
    };

    handleOnUnselectAll = () => {
        this.props.onUnselectAll();
    };

    render() {
        let actions = this.props.additionalActions || [];
        actions = actions.map((action, index) => (
            <div key={`action-${index}`} className='mr-1' hidden={action.hidden}>
                <div onClick={action.onClick} id={`table-action-${index}`}>
                    <i className={'mdi float-toolbar-button cursor-pointer ' + action.classNames}/>
                </div>
                <UncontrolledTooltip placement='top' target={`table-action-${index}`}>
                    {action.tooltip}
                </UncontrolledTooltip>
            </div>
        ));
        return (
            <FloatToolbar show={this.props.selectedItems && this.props.selectedItems.length > 0}
                          onClose={this.handleOnUnselectAll}>
                <div className='mr-2'>
                    <span className='mr-1'>Selected</span>
                    <Pluralize singular={'item'}
                               count={this.props.selectedItems ? this.props.selectedItems.length : 0}/>
                </div>
                <div className='d-flex flex-row mr-2'>
                    {this.props.onView && <div className='mr-1'
                                               hidden={!this.props.selectedItems || this.props.selectedItems.length > 1 || !this.props.onView}>
                        <div onClick={this.handleOnView} id='view-selected'>
                            <i className='mdi mdi-eye float-toolbar-button cursor-pointer'/>
                        </div>
                        <UncontrolledTooltip placement='top' target='view-selected'>
                            View selected item
                        </UncontrolledTooltip>
                    </div>}
                    {this.props.onEdit &&
                    <div
                        hidden={!this.props.selectedItems || this.props.selectedItems.length > 1 || !this.props.hasModifyPermission}
                        className='mr-1'>
                        <div onClick={this.handleOnEdit} id='edit-selected'>
                            <i className='mdi mdi-pencil float-toolbar-button cursor-pointer'/>
                        </div>
                        <UncontrolledTooltip placement='top' target='edit-selected'>
                            Edit selected item
                        </UncontrolledTooltip>
                    </div>}
                    <div className='mr-1' hidden={!this.props.hasModifyPermission || !this.props.onDelete}>
                        <div onClick={this.handleOnDelete} id='delete-selected'>
                            <i className='mdi mdi-delete float-toolbar-button cursor-pointer'/>
                        </div>
                        <UncontrolledTooltip placement='top' target='delete-selected'>
                            Delete selected items
                        </UncontrolledTooltip>
                    </div>
                    {actions}
                </div>
            </FloatToolbar>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

export default connect(
    mapStateToProps,
    {openConfirmation}
)(TableFloatToolbar);
